import { Typography } from "antd";
import NmmUpdatesTable from "components/Resources/NmmUpdatesTable";
import './index.scss';

const { Title } = Typography;

const NmmUpdatesPage = () => {

  return (
    <div className="nmm-updates-page">
      <div className="header-title">
        <Title level={4}>&nbsp;&nbsp;&nbsp;Astrana Updates</Title>
      </div>
      <div className="content">
        <NmmUpdatesTable />
      </div>
    </div>
  );
}

export default NmmUpdatesPage;